/**
 * The attendance status tags. Two of them, because the same stored status means different
 * things depending on what you're looking at:
 *
 *   <PresenceTag>  daily views   → Present / Absent
 *   <DayTypeTag>   monthly views → Full day / Half day / Absent
 *
 * Label, colour and tooltip travel together here so a call site can't pair "Absent" with
 * a green pill. See statusUtils for why the two vocabularies are separate.
 */
import StatusTag from '../../components/common/StatusTag';
import {
  presenceLabel, presenceTone,
  consolidatedLabel, consolidatedTone, consolidatedHint,
} from './statusUtils';

/** Daily: was this person on site? */
export function PresenceTag({ status }: { status?: string | null }) {
  return <StatusTag tone={presenceTone(status)}>{presenceLabel(status)}</StatusTag>;
}

/** Monthly consolidated: what kind of day did this count as? */
export function DayTypeTag({ status }: { status?: string | null }) {
  return (
    <StatusTag tone={consolidatedTone(status)} title={consolidatedHint(status)}>
      {consolidatedLabel(status)}
    </StatusTag>
  );
}
